export default class SortUtils{
  static sortBolsas(bolsas){
    bolsas.sort((a, b) => a.sigla.localeCompare(b.sigla));
  }
  static sortCursos(cursos){
    cursos.sort((a, b) => a.curso.localeCompare(b.curso));
  }
}